import {Lang} from "../types/lang";

export const routeName = {
    home: '/',
    privacy: '/privacy',
    termsOfUse: '/terms-of-use',
    deleteAccount: '/delete-account',
}


export const lngCode = {
    sv: 'sv',
    en: 'en',
    es: 'es',
}
export const I18nLng = new Map<string, Lang>([
    [lngCode.sv, {nativeName: 'Svenska'}],
    [lngCode.en, {nativeName: 'English'}],
    [lngCode.es, {nativeName: 'Español'}]
]);
